module.exports = __webpack_public_path__ + "img/calendar-29.45947924.svg";